import {StorageDbConfig} from './storage-db-config';
export const STORAGE_DB_CONFIG: StorageDbConfig = {
  version: 1,
  name: 'mydb',
  tables: {}
};
